// extracted by mini-css-extract-plugin
export default {"submit":"CreateWorkFocusedPlanPage_submit__oehOD"};